const PLAYBACK_THRESHOLD_PERCENT = 99;
const IN_PROGRESS_CLE_CLAMP_PERCENTAGE = 95;

interface PlaybackProgress {
    position: number;
    totalTime: number;
}

const normalizePercentComplete = (percentComplete: number) => {
    if (!Number.isFinite(percentComplete)) return 0;

    return Math.min(Math.max(percentComplete, 0), 100);
};

export const getOnDemandCreditPercentComplete = (
    recordedPercentComplete = 0,
    playbackProgress?: PlaybackProgress | null,
) => {
    const normalizedPercentComplete = normalizePercentComplete(recordedPercentComplete);

    if (!playbackProgress
        || !Number.isFinite(playbackProgress.position)
        || !Number.isFinite(playbackProgress.totalTime)
        || playbackProgress.position <= 0
        || playbackProgress.totalTime <= 0) {
        return normalizedPercentComplete;
    }

    const progressTarget = playbackProgress.totalTime * (PLAYBACK_THRESHOLD_PERCENT / 100);

    return playbackProgress.position < progressTarget
        ? Math.min(normalizedPercentComplete, IN_PROGRESS_CLE_CLAMP_PERCENTAGE)
        : normalizedPercentComplete;
};
